import ActionType from './type';

export const updateVisContainerSize = (containerSize) => ({
    type: ActionType.UPDATE_VIS_CONTAINER_SIZE,
    containerSize
})